import { defineNuxtRouteMiddleware, useState, abortNavigation, useNuxtApp, useI18n } from '#imports'

export default defineNuxtRouteMiddleware(async (to) => {
    const { $apiFetch } = useNuxtApp()
    
    // Getting locale from url
    const localeFromUrl = to.params.locale || to.path.split('/')[1] || 'en'

    
    // If route already exists, do nothing
    if (!to.matched?.[0]?.name?.includes('dynamic-fallback')) {
        return
    }

    // Remove localization prefix
    const requested_path = to.fullPath
    const pageData = useState<any>('dynamic-content-' + requested_path)
    // Replacing lang prefix from path
    const path = requested_path.replace('/ru', '').replace('/en', '')

    if (!pageData.value) {
        try {
            // Используем полученную локаль в API запросе
            const data = await $apiFetch(`${localeFromUrl}/api/site/staticpages${path}`)

            if (!data) {
                return abortNavigation({
                statusCode: 404,
                statusMessage: 'Page not found',
                })
            }

            pageData.value = data
        } catch (err) {
            console.error('Error fetching dynamic content: ', to.fullPath, err)
            return abortNavigation({
                statusCode: 404,
                statusMessage: 'Page not found',
            })
        }
    }
})